module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--contact main--full-height"
  }, [_c('div', {
    staticClass: "contact group group--indent"
  }, [_c('div', {
    staticClass: "contact__header"
  }, [_c('div', [_c('h1', {
    staticClass: "h1 mt0 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("We’re here for you at")]), _vm._v(" "), _c('h1', {
    staticClass: "h1 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_c('a', {
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_vm._v(_vm._s(_vm.number))])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("We’ll answer any questions and help you find the right person to talk to. You’ll also be able to cancel or reschedule your conversation.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _vm._v(" "), _c('img', {
    staticClass: "contact__img",
    attrs: {
      "src": _vm.illustrationImage,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contact__content"
  }, [_c('h2', {
    staticClass: "h2 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Are you in an emergency?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    staticClass: "h2 mt",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Need to help someone other than yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("If you’re a manager and need to know how to best help a troubled employee, please call us at "), _c('a', {
    staticClass: "tdn link",
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v(" If a partner, friend, or co-worker needs help, that person will need to register. Share this URL so they can get started.")]), _vm._v(" "), _c('a', {
    staticClass: "p tdn fw-bold c-accent ",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "href": _vm.org.share_url
    }
  }, [_vm._v(_vm._s(_vm.org.share_url))]), _vm._v(" "), (_vm.org.show_international_section) ? _c('div', [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Not in the U.S?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Find international resources and phone numbers on our "), _c('a', {
    staticClass: "c-accent tdn fw-bold",
    attrs: {
      "href": "http://www.achievesolutionsglobal.net"
    }
  }, [_vm._v("international website")]), _vm._v(". Use the company code " + _vm._s(_vm.org.company_code) + ".")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p fw-bold"
  }, [_vm._v("If you are experiencing a mental health crisis, dial "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": "tel:988"
    }
  }, [_vm._v("988")]), _vm._v(" now.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "p fw-bold"
  }, [_vm._v("For all other emergencies, dial "), _c('a', {
    staticClass: "tdn",
    attrs: {
      "href": "tel:911"
    }
  }, [_vm._v("911")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c372b3d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/Contact.vue
// module id = 553
// module chunks = 0